import type {RouteRecordRaw} from 'vue-router';
import {createPropositionGuard} from '@myparcel-frontend/proposition';
import {shopSettingsCompanyRoutes} from './company.routes';
import {shopSettingsEmailRoutes} from './emails.routes';
import {shopSettingsReturnsRoutes} from './returns.routes';
import {shopSettingsRulesRoutes} from './rules.routes';
import {shopSettingsSalesChannelsRoutes} from './sales-channels.routes';
import {shopSettingsShipmentRoutes} from './shipment.routes';
import {fulfilmentGuard} from '../guards/fulfilment-guard';

export const shopSettingsRoutes: RouteRecordRaw[] = [
  {
    path: '/settings/:shopId',
    name: 'shop-settings',
    meta: {
      permissions: ['updateShopBranding'],
      title: (t) => t('settings.general'),
      titleBarHeader: (t) => t('shipment.index.shipment', 2),
    },
    children: [
      {
        path: '',
        name: 'shop-settings-general',
        component: () => import('@/views/Settings/Shop/Shipment/General/General.vue'),
        meta: {
          feature: 'page.settings.shop.general',
          permissions: ['selectApiKey', 'selectWebhookSubscription', 'updateShopGeneralSettings'],
          title: (t) => t('settings.general'),
        },
      },
      {
        path: 'branding',
        name: 'shop-settings.branding',
        component: () => import('@/views/Settings/Shop/Branding/Branding.vue'),
        meta: {
          permissions: ['updateShopBranding'],
          title: (t) => t('settings.shop.branding.title'),
        },
      },
      ...shopSettingsEmailRoutes,
      {
        path: 'orders',
        name: 'shop-settings-orders',
        component: () => import('@/views/Settings/Shop/Order/OrderSettings.vue'),
        beforeEnter: [
          createPropositionGuard((proposition) => proposition.enableFulfilment, {
            name: 'dashboard',
          }),
          fulfilmentGuard,
        ],
        meta: {
          permissions: ['selectApiKey', 'selectWebhookSubscription', 'updateShopBranding'],
          title: (t) => t('subscriptions.myOrders.banner'),
          titleBarHeader: 'subscriptions.myOrders.banner',
        },
      },
      {
        name: 'shop-settings-track-trace',
        path: 'track-and-trace',
        component: () => import('@/views/Empty.vue'),
        meta: {
          feature: 'page.settings.shop.trackTrace',
          permissions: ['updateShopTrackTraceSettings'],
          title: (t) => t('shipment.trackTrace'),
        },
      },
      {
        name: 'shop-settings-portal',
        path: 'portal-settings',
        component: () => import('@/views/Settings/Shop/TrackAndTrace/PortalIndex.vue'),
        meta: {
          permissions: [
            'selectConsumerPortalFields',
            'insertConsumerPortalFields',
            'updateConsumerPortalFields',
            'checkConsumerPortalSubdomain',
          ],
          title: (t) => t('settings.shop.portal.title'),
        },
      },
      {
        name: 'shop-settings-integration',
        path: 'integration',
        component: () => import('@/views/Settings/Shop/Integrations/Integrations.vue'),
        beforeEnter: createPropositionGuard((proposition) => proposition.settings.enableIntegrations, {
          name: 'dashboard',
        }),
        meta: {
          permissions: [
            'selectApiKey',
            'selectWebhookSubscription',
            'updateShopGeneralSettings',
            'updateExternalIntegrationProviderCredentials',
          ],
          provider: null,
          title: (t) => t('integrations.title'),
        },
      },
      ...shopSettingsCompanyRoutes,
      ...shopSettingsReturnsRoutes,
      ...shopSettingsRulesRoutes,
      ...shopSettingsShipmentRoutes,
      ...shopSettingsSalesChannelsRoutes,
    ],
  },
];
